declare global {
  interface Window {
    fbq?: {
      init(pixelId: string): void;
      (command: string, eventName: string, params?: Record<string, unknown>): void;
    };
  }
}

/**
 * this function is not pretty in any means, but its required to have facebook events.
 * TODO: we could look into typing each variable on a suitable time.
 * @param pixel PixelItemState
 */
export const loadFBSdk = () => {
  // @ts-ignore
  if (window.fbq) return false;

  // @ts-ignore
  // eslint-disable-next-line no-unused-expressions
  !(function (f, b, e, v, n, t, s) {
    // @ts-ignore
    if (f.fbq) return;
    // @ts-ignore
    n = f.fbq = function () {
      // @ts-ignore
      // eslint-disable-next-line prefer-rest-params,prefer-spread
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    // @ts-ignore
    if (!f._fbq) f._fbq = n;
    // @ts-ignore
    n.push = n;
    // @ts-ignore
    n.loaded = !0;
    // @ts-ignore
    n.version = '2.0';
    // @ts-ignore
    n.queue = [];
    // @ts-ignore
    t = b.createElement(e);
    // @ts-ignore
    t.async = !0;
    // @ts-ignore
    t.src = v;
    // @ts-ignore
    s = b.getElementsByTagName(e)[0];
    // @ts-ignore
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  // @ts-ignore

  return true;
};
